require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-kobersdorf.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-kobersdorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-kobersdorf!./.cache/json/betreuungseinrichtungen-oberpullendorf-kobersdorf.json
// module id = 977
// module chunks = 231608221292675